// src/redux/slices/lpn/lpnApiSlice.ts
import { apiSlice } from "@/redux/apiSlice";

export const lpnApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLpnNumbers: builder.query({
      query: (palletId) => `/projects/getLpnNumbers/${palletId}`,
      transformResponse: (response: { lpnNumbers: LpnNumber[] }) => {
        // Ensure endStatusPallet is included in the response
        return {
          lpnNumbers: response.lpnNumbers.map(lpn => ({
            ...lpn,
            endStatusPallet: lpn.endStatusPallet || ''
          }))
        };
      },
      providesTags: (result, error, palletId) => 
        result
          ? [
              { type: 'LpnNumbers' as const, id: palletId },
              ...result.lpnNumbers.map(lpn => ({ type: 'LpnNumbers' as const, id: lpn.id })),
              { type: 'LpnNumbers' as const, id: 'LIST' }
            ]
          : [{ type: 'LpnNumbers' as const, id: 'LIST' }],
    }),
    createLpnNumbers: builder.mutation<{ lpnNumbers: LpnNumber[] }, { palletId: number; lpnNumbers: LpnNumber[] }>({
      query: (body) => ({
        url: '/projects/createLpnNumbers',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { palletId }) => [
        { type: 'LpnNumbers' as const, id: palletId },
        { type: 'LpnNumbers' as const, id: 'LIST' },
        'PalletConfig'
      ],
    }),
  }),
});

export const {
  useGetLpnNumbersQuery, 
  useCreateLpnNumbersMutation
} = lpnApiSlice;

interface LpnNumber {
  id?: number;
  lpnNo: string;
  endStatusPallet: string;
}